// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + "shipbob_ai_control_hub_ui_styles" + "." + "ce419936" + ".chunk.css";
};